export default __webpack_public_path__ + "static/media/Pharmacy_supply_algorithm.dfb82d47.pdf";